module.exports = __webpack_public_path__ + "static/media/ApplyCoupon.bb7bc586.svg";